<template>
	<span :class="`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-${this.color}-100 text-${this.color}-800`">
        <slot></slot>
    </span>
</template>

<script>
	export default {
		props: {
		    color: {
		        type: String,
                default: 'green',
            }
        }
	}
</script>
